// Libs
import * as R from 'ramda';

export enum ClubTypeEnum {
  RotaryClub = 'Rotary Club',
  RotaractClub = 'Rotaract Club',
  SatelliteClub = 'Satellite Club',
  RotaractSatelliteClub = 'Rotaract Satellite Club',
}

export const isRotaryClub = (clubType?: string): boolean =>
  R.equals(clubType, ClubTypeEnum.RotaryClub);
